import { FunSun, PRICE_VOLATILE_PROVIDERS } from './config';

export const isFunSun = (providerClass: string) => {
  return providerClass === FunSun;
};

/**
 * Whether the offer's provider does not fix the fare price until ticketing,
 * so the user must be warned the price may change before booking (e.g. Kiwi).
 */
export const isPriceVolatileProvider = (providerClass?: string | null) =>
  PRICE_VOLATILE_PROVIDERS.includes(providerClass ?? '');
